/**
 * Step titles of the share-transfer process, for the notary and support view and its timeline.
 * Only the states whose incorporation title (`INCORPORATION.<STATE>.<TYPE>.TITLE`) is wrong for a
 * share transfer, or missing; the rest fall back to the incorporation's.
 */
const title = (notary: string, support = notary) => ({ NOTARY: { TITLE: notary }, SUPPORT: { TITLE: support } });

export const TRANSLATIONS = {
    EN: {
        SHARE_TRANSFER: {
            APPROVE_CONCEPT: {
                ...title('Waiting for approval of the draft deed'),
                NOTARY_DESCRIPTION:
                    'The applicant has received the draft deed, reviews it and will then approve the deed. If the applicant has already approved the draft deed during the meeting, you can approve the deed yourself.',
            },
            WAIT_FOR_SIGNING: title('Waiting for the sellers and receivers to sign'),
            CONFIRM_DISCUSSION: title('Discussion of the draft deed'),
            FINALIZE_DEED: title('Upload final deed'),
            PROCESS_PAUSED: title('Process paused'),
            FAILED: title('Failed'),
            TIMEOUT: title('Timed out'),
        },
    },
    NL: {
        SHARE_TRANSFER: {
            APPROVE_CONCEPT: {
                ...title('Wachten op goedkeuring conceptakte'),
                NOTARY_DESCRIPTION:
                    'De aanvrager heeft de conceptakte ontvangen, neemt deze door en zal de akte vervolgens goedkeuren. Als de aanvrager de conceptakte al heeft goedgekeurd tijdens de bespreking, kun je zelf de akte goedkeuren.',
            },
            WAIT_FOR_SIGNING: title('Wacht op ondertekening door de verkopers en ontvangers'),
            CONFIRM_DISCUSSION: title('Bespreking conceptakte'),
            FINALIZE_DEED: title('Voltooi de akte'),
            PROCESS_PAUSED: title('Proces gepauzeerd'),
            FAILED: title('Mislukt'),
            TIMEOUT: title('Verlopen'),
        },
    },
};
